<template>
    <v-card>
        <v-card-text>
            <v-row justify="center">
                <v-col cols="6">
                    <work-space-form ref="form" @updated="onUpdatedForm" :workspace="WORKSPACE"></work-space-form>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import WorkSpaceForm from "../components/workspace/WorkSpaceForm.vue";
import {mapActions, mapGetters} from "vuex";

export default {
    name: "WorkSpaceSettingsPage",
    components: {WorkSpaceForm},
    computed:{
        ...mapGetters('workspace', ['WORKSPACE']),
    },
    methods:{
        ...mapActions('workspace', ['SET_WORK_SPACE']),
        ...mapActions('workspaceList', ['REPLACE']),
        onUpdatedForm(e){
            this.SET_WORK_SPACE(e.data).then(() => {
                this.$refs.form.reset();
            });
            this.REPLACE(e.data);
        }
    }
}
</script>

<style scoped>

</style>